export default "__VITE_ASSET__D_sza9QK__"